import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Row, Col, Label,
  Input, InputGroup,
  FormFeedback, TabContent,
  TabPane, Nav, NavItem,
  NavLink, Card, Button,
  CardTitle, CardText,
  Table
} from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../../../components/ParadigmaAsyncSeeker/";

import api from "../../../../../api";
import apifunctions from "../../../../../api/functions.js";

import '../styles.css';


class TabPropiedades extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Propiedades: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    const successCallback = (data) => {
      let ValoresDeArticulo = nextProps.data.Valores;
      let Propiedades = data.data ? data.data : [];
      Propiedades.forEach((p) => {
        p.ValoresSeleccionados = p.ValoresDePropiedad.filter(v => ValoresDeArticulo.filter(item => item.id == v.id).length > 0).map(item => item.id);
      });

      this.setState({ Propiedades: Propiedades });
    };
    const failureCallback = () => this.setState({ Propiedades: [] });
    apifunctions.get(api.gestion.articulos.propiedades, null, null, { filters: ["paginationEnabled=False"] }, successCallback, failureCallback, failureCallback);
  }

  updateProperty(prop_id, data) {
    const { onChangeField } = this.props;
    let { Propiedades } = this.state;
    let ValoresDeArticulo = [...this.props.data.Valores];

    ValoresDeArticulo = ValoresDeArticulo.filter(val => val.Propiedad_id != prop_id);
    data.forEach(v => ValoresDeArticulo.push(v));

    Propiedades.forEach((p) => {
      p.ValoresSeleccionados = p.ValoresDePropiedad.filter(v => ValoresDeArticulo.filter(item => item.id == v.id).length > 0).map(item => item.id);
    });

    this.setState({ Propiedades: Propiedades }, () => onChangeField("Valores", ValoresDeArticulo));
  }

  render() {
    const { vars } = this.props;
    const { Propiedades } = this.state;
    return (
      <TabPane tabId="3" className="modalArticuloTabContainer modalArticuloTabContainer-Propiedades">
        {
          this.state.Propiedades.length > 0 ?
            <Table striped>
              <thead>
                <tr>
                  <th>Propiedad</th>
                  <th>Valores</th>
                </tr>
              </thead>
              <tbody>
                {
                  Propiedades.map((p, index) => (
                    <tr key={"prop-" + index}>
                      <td>{p.Nombre.toUpperCase()}</td>
                      <td>
                        <ParadigmaAsyncSeeker
                          disabled={vars.disabled}
                          value={p.ValoresSeleccionados}
                          optionDefault={p.ValoresDePropiedad}
                          multiselect={true}
                          displayField="Nombre"
                          onChange={(data) => this.updateProperty(p.id, data)}
                        />
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </Table>
            :
            <p>No existen Propiedades asignables.</p>
        }

      </TabPane>
    );
  }
}

export default TabPropiedades;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Articulos/ModalArticulo/TabPropiedades.js